import Image from "next/image";
import { IoMdCalendar } from "react-icons/io";
import { MdOutlineAccessTime } from "react-icons/md";

import { Badge } from "@/common/components/badge";
import { MigrationLink } from "@/common/components-2/migration-link";

import {
  getArticleCardClass,
  getCoverImageClass,
  getDescriptionClass,
  getFooterMetaClass,
  getTitleClass,
} from "./article-card.styles";
import type { ArticleCardProps } from "./article-card.types";

export function ArticleCard({
  className,
  title,
  description,
  category,
  image,
  timeToRead,
  date,
  link,
  ...props
}: ArticleCardProps) {
  return (
    <div className={getArticleCardClass({ className })} {...props}>
      <MigrationLink href={link}>
        <Image src={image.url} alt={image.title} width={400} height={300} className={getCoverImageClass()} />
      </MigrationLink>
      <div className="flex-1 px-6">
        <div className="flex h-full flex-col border-b py-5">
          <div>
            <Badge variant="secondary" size="xs" className="text-sm lg:text-base">
              {category}
            </Badge>
          </div>
          <MigrationLink href={link} className={getTitleClass()}>
            {title}
          </MigrationLink>
          <p className={getDescriptionClass()}>{description}</p>
        </div>
      </div>
      <div className="flex justify-end gap-5 px-8 py-5">
        <span className={getFooterMetaClass()}>
          <MdOutlineAccessTime className="text-xl" />
          {timeToRead}
        </span>
        <span className={getFooterMetaClass()}>
          <IoMdCalendar className="text-xl" />
          {date}
        </span>
      </div>
    </div>
  );
}
